import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import translate from '../other/translate.json';
import clsx from 'clsx';
import config from '../other/config';
const { serverAPI } = config;

const CustomTypography = withStyles((theme) => ({
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: '500',
    color: '#24262A'
  },

  body1: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#8987A2'
  },

  gutterBottom: {
    marginBottom: 20
  },
  
}))(Typography);

export default function Cookie(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru'

  return (
    language === 'Ru' 
      ?
      <Grid container>
        <Grid item lg={12} md={12} sm={12} style={{ padding: 0 }}>
          <CustomTypography variant="h1" gutterBottom>Контакты</CustomTypography>
        </Grid>       
     
        <Grid item lg={6} md={6} sm={6} style={{ padding: 0 }}>
          <CustomTypography variant="h4" gutterBottom>Москва</CustomTypography>
          <CustomTypography>Россия, 125284, Москва,<br/>
          Ленинградский пр-т, 31А стр.1 (М.Динамо),<br/>
          БЦ «Монарх», 17 этаж<br/>
          тел.: <a href="tel:+74957805012" className={classes.LinkType2} target="_blank" rel="nofollow noopener">(495) 780-50-12</a><br/>
          e-mail: <a href="mailto:market@cft.ru" className={classes.LinkType2} target="_blank" rel="nofollow noopener">market@cft.ru</a></CustomTypography>          
        </Grid>
        <Grid item lg={6} md={6} sm={6} style={{ padding: 0 }}>
          <CustomTypography variant="h4" gutterBottom>Новосибирск</CustomTypography>
          <CustomTypography variant="body1" gutterBottom>Россия, 630055, Новосибирск,<br/>
          ул. Шатурская, 2,<br/>
          тел.: <a href="tel:+73833364949" className={classes.LinkType2} target="_blank" rel="nofollow noopener">336-49-49</a><br/>
          тел.: <a href="tel:+74957805012" className={classes.LinkType2} target="_blank" rel="nofollow noopener">8-495-780-50-12 (многоканальный)</a><br/>
          e-mail: <a href="mailto:market@cft.ru" className={classes.LinkType2} target="_blank" rel="nofollow noopener">market@cft.ru</a></CustomTypography>          
        </Grid>
      </Grid>
      :
      <Grid container>
      <Grid item lg={12} md={12} sm={12} style={{ padding: 0 }}>
        <CustomTypography variant="h1" gutterBottom>Contacts</CustomTypography>
      </Grid>       
   
      <Grid item lg={6} md={6} sm={6} style={{ padding: 0 }}>
        <CustomTypography variant="h4" gutterBottom>Moscow</CustomTypography>
        <CustomTypography>BC Monarch, 17th floor<br/>
        31A building 1, Leningradsky Ave (M. Dynamo)<br/>
        125284, Moscow, Russia<br/>
        tel.:  <a href="tel:+74957805012" className={classes.LinkType2} target="_blank" rel="nofollow noopener">(495) 780-50-12</a><br/>
        e-mail: <a href="mailto:market@cft.ru" className={classes.LinkType2} target="_blank" rel="nofollow noopener">market@cft.ru</a></CustomTypography>          
      </Grid>
      <Grid item lg={6} md={6} sm={6} style={{ padding: 0 }}>
        <CustomTypography variant="h4" gutterBottom>Novosibirsk</CustomTypography>
        <CustomTypography variant="body1" gutterBottom>2, Shaturskaya Str<br/>
        630055, Novosibirsk, Russia<br/>
        tel.:  <a href="tel:+73833364949" className={classes.LinkType2} target="_blank" rel="nofollow noopener">336-49-49</a><br/>
        tel.:  <a href="tel:+74957805012" className={classes.LinkType2} target="_blank" rel="nofollow noopener">8-495-780-50-12 (multichannel)</a><br/>
        e-mail: <a href="mailto:market@cft.ru" className={classes.LinkType2} target="_blank" rel="nofollow noopener">market@cft.ru</a></CustomTypography>          
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    boxShadow: 'none',
    padding: 24,
    height: 'fit-content',

    [theme.breakpoints.down(696)]: {
      padding: 0,
      backgroundColor: 'transparent',
    }
  },

  LinkType2: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: '#8987A2',
    textDecoration: 'none',

    '&:hover': {
      color: '#24262A',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
    }
  },
  LinkType2:{
    // fontFamily: 'Cera CY',
    // fontStyle: 'normal',
    // fontWeight: 'normal',
    // fontSize: '16px',
    // lineHeight: '24px',
    // color: '#24262A',

    // '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      }},
}));